export default "__VITE_ASSET__DZswfC$I__"